export const mutations = {
  addAgregateur (state, agregateur) {
    state.agregateur = agregateur
  },
  setAgregateur (state, agregateur) {
    state.agregateur = agregateur
  },
    addAgregateurs(state, agregateur){
    state.agregateurs = [ ...agregateur ]
  },
  addAgregateurPage(state, agregateur) {
    state.agregateurs = agregateur
  }
}
